import Storage from '@/utils/storage'
const currencyToCountryMap = {
  NGN: 'ng',
  BRL: 'br',
  INR: 'in',
}
export function getSelectedSiteCountry() {
  const site = Storage.get('SelectedWebsite')
  const currency = site?.currency
  return currency ? currencyToCountryMap[currency] : 'br'
}

const national = getSelectedSiteCountry() || 'br'
const defaultCountry = national
const currencyMap = {
  br: 'BRL',
  ng: 'NGN',
  in: 'INR',
}
const currencyUnitMap = {
  br: 'R$',
  ng: '₦',
  in: '₹',
}
const timeZoneMap = {
  br: 'America/Sao_Paulo',
  ng: 'Africa/Lagos',
  in: 'Asia/Kolkata',
}
const countryCnNameMap = {
  br: '巴西',
  ng: '尼日利亚',
  in: '印度',
}

export const LanguageMap = {
  EN: 'en',
  'ZH-CN': 'cn',
  'PT-BR': 'pt',
}

const countryLanguageMap = {
  br: 'PT-BR',
  ng: 'EN',
  in: 'EN',
}

const languageOptions = [
  { value: 'EN', label: '英语' },
  { value: 'PT-BR', label: '葡萄牙语(巴西)' },
]
const countryDefaultLanguage = languageOptions.find(option => option.value === countryLanguageMap[defaultCountry])
console.log('countryDefaultLanguage', countryDefaultLanguage)

const localeMap = {
  br: 'pt-BR',
  ng: 'en-US',
  in: 'en-IN',
}

const config = {
  countryCnNameMap,
  currencyToCountryMap,
  countryLanguageMap,
  defaultCountry,
  countryDefaultLanguage,
  languageOptions,
  locale: localeMap[defaultCountry],
  countryCnName: countryCnNameMap[defaultCountry],
  timeZone: timeZoneMap[defaultCountry],
  country: defaultCountry,
  amountUnit: currencyUnitMap[defaultCountry],
  currency: currencyMap[defaultCountry],
  languages: [
    //代理后台切换语言用
    { value: 'EN', label: '英语' },
    { value: 'PT-BR', label: '葡萄牙语(巴西)' },
    // { value: 'EN', label: '英语(印度)' },
  ],
}

export default config
